/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'

import {
  message, Modal, Button, Row, Col, Form, Typography,
} from 'antd'

import { ExclamationCircleOutlined } from '@ant-design/icons'

import ReactQuill from 'react-quill'

import NumberFormat from 'react-number-format'

import { differenceInDays, parse } from 'date-fns'

import { fetch } from '../../../utils/fetch'

import { sumPaymentState, netPriceState } from '../../../store/atoms'

const { Text } = Typography
const { confirm } = Modal

const CommentModal = ({
  orderId, visible, onCancel, onSuccess, title, delvDate,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [remark, setRemark] = useState('')
  const [netPrice] = useRecoilState(netPriceState)
  const [sumPayment] = useRecoilState(sumPaymentState)

  const handleChange = (value) => {
    setRemark(value)
  }

  useEffect(() => {
    if (visible) {
      setRemark('')
    }
  }, [visible])

  return (
    <Modal
      title={title}
      visible={visible}
      onCancel={onCancel}
      maskClosable={false}
      footer={[
        <Button loading={isLoading} onClick={() => { onCancel() }}>
          Cancel
        </Button>,
        <Button type="primary" loading={isLoading} onClick={() => { onSuccess(remark) }}>
          {title === 'Approve' ? 'Approve' : 'Revise'}
        </Button>,
      ]}
    >
      <Row>
        <Col>
          <Form layout="vertical">
            <Row gutter={{ md: 24, lg: 32 }}>
              <Col className="gutter-row" span={12}>
                <Form.Item label="Remaining">
                  {delvDate ? (
                    <>
                      {differenceInDays(
                        parse(delvDate, 'yyyy.MM.dd', new Date()),
                        new Date())}
                      {' days'}
                    </>
                  ) : '-'}
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={12}>
                <Form.Item label="Outstanding/Paid">
                  <NumberFormat thousandSeparator fixedDecimalScale decimalScale={2} displayType="text" value={netPrice} />/
                  {
                  sumPayment === netPrice && <Text type="success"><NumberFormat thousandSeparator fixedDecimalScale decimalScale={2} displayType="text" value={sumPayment} /></Text>
                }
                  {
                  sumPayment !== netPrice && <Text type="warning"><NumberFormat thousandSeparator fixedDecimalScale decimalScale={2} displayType="text" value={sumPayment} /></Text>
                }
                  {' THB '}
                  {
                  sumPayment !== netPrice
                  && (
                  <>
                    <Text type="secondary">
                      {'(Remaining: '}
                      <NumberFormat thousandSeparator fixedDecimalScale decimalScale={2} displayType="text" value={Number(netPrice) - Number(sumPayment)} />
                      {' THB)'}
                    </Text>
                  </>
                  )
                }
                </Form.Item>
              </Col>
            </Row>

          </Form>

        </Col>
      </Row>
      Comment:
      <ReactQuill onChange={handleChange} value={remark} />

    </Modal>
  )
}

export default CommentModal

